module.exports = __webpack_public_path__ + "img/专家工作站.803f139b.jpg";